<template>
    <!-- <div class="about">
      <h1>This is an about page</h1>
    </div>-->
    <div class="park_select">
        <div class="park_list">
            <div class="park_item" v-for="item in parkInfo" :key="item.id">
                <div @click="goParkHome(item)">{{ item.name }}</div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scope="scoped">
    .park_select {
        .park_list {
            display: flex;

            .park_item {
                margin: 10px;
                background-color: #008dfe;
                padding: 10px;
                border-radius: 3.5px;
                color: #fff;
                cursor: pointer;
            }
        }
    }
</style>

<script>
    import theme from "echarts/theme/shine.js";

    export default {
        data() {
            return {
                parkInfo: []
            };
        },
        mounted() {
            let parkInfo = this.$Local.getLocal("parks", "object");
            this.parkInfo = parkInfo;
        },
        methods: {
            goParkHome(item) {
                this.$Local.setLocal(
                    ["park", "bindCompanies"],
                    [[item], item.companyList]
                );

                this.$router.push("/home");
            }
        }
    };
</script>